import { lazy } from 'react';
import { NotFoundPage } from '@lingoda/fallbacks';
import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';
import {
    type RouteConfigExtended,
    TabValue,
    studentWritingExamPrepExercisePath,
} from '@lingoda/router';
import { LinearProgress } from '@lingoda/ui';

const ExercisePage = lazy(() => import('./ExercisePage/ExercisePage'));

const ExerciseRoute = () => {
    const feature = useFeatureFlagValue(KameleoonFlagKey.writingExamPrep);

    if (feature.isLoading) {
        return <LinearProgress />;
    }

    if (!feature.isVariant) {
        return <NotFoundPage />;
    }

    return <ExercisePage />;
};

export const writingExamPrepRoutes: RouteConfigExtended[] = [
    {
        exact: true,
        component: ExerciseRoute,
        path: studentWritingExamPrepExercisePath.raw,
        label: 'Writing exam prep',
        config: {
            hideHeader: true,
            hideFooter: true,
            hideDixa: true,
            hideMobileBottomNavbar: true,
            hideNotifications: true,
            tab: TabValue.Practice,
        },
    },
];
